import * as React from 'react';

import SkillMain from '../../components/SkillMain';
import MainMenu from '../../containers/MainMenu';
import Navbar from '../../containers/Navbar';
import i18n from '../../resources/i18n';
/**
 * スキル情報画面
 * @param props
 */
const Skill: React.FC<any> = props => {
	return (
		<>
			<MainMenu />
			<Navbar title={i18n.t('Skill_0001')} />
			<SkillMain adminView={false} userId={props.match.params.user_id} />
		</>
	);
};

export default Skill;



// WEBPACK FOOTER //
// ./src/pages/personal/Skill.tsx